<template>
  <div class="basicinfo-wrap">
    <section class="banner-leave-message bgs-cover bgp-c d-f ai-c jc-c">
      <h1 class="banner-title c-fff ta-c">Free Quote</h1>
    </section>
    <!-- banner:end -->
    <div class="content">
      <div class="form-wrapper p-r">
        <i class="bg-img d-b p-a"></i>
        <div class="form-container p-r z-3">
          <h2 class="ta-c c-333">Basic Information</h2>
          <dealerForm base-info></dealerForm>
          <!--#include virtual="/allSiteCommon/newForm/newForm.html"-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dealerForm from '@/components/dealerForm'

  export default {
    components: {
      dealerForm
    },
    data() {
      return {}
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .basicinfo-wrap {
    padding-top: 0.76rem;
  }
  .banner-leave-message {
    height: 3.6rem;
    background-image: url('@/assets/images/leave-message/banner.jpg');
  }
  .banner-title {
    font-size: 0.48rem;
  }
  .content {
    padding: 0.64rem 0.56rem 1rem;
  }
  .form-wrapper {
    margin-top: 0.48rem;
    min-height: 9.08rem;
    background-color: #fafafa;
  }
  .form-wrapper .bg-img {
    width: 4.95rem;
    height: 9.08rem;
    top: 0.33rem;
    right: 0.6rem;
    background: url('@/assets/images/leave-message/form-bg.png') no-repeat center / cover;
  }
  .form-container {
    padding: 0.64rem 0 0.72rem;
  }
  .form-container h2 {
    margin-bottom: 0.45rem;
    font-size: 0.32rem;
    font-weight: 500;
  }
</style>
